module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-7-2x-0fa063e00a1cbd689dcd24133b083cb5.jpg";